import React, { forwardRef, memo, useImperativeHandle, useState } from 'react'
import { SeriesGroup } from '../chart.typings'
import ChartContextMenuOptions from './chartContextMenuOptions'

export type ChartContextMenuAnchor = {
    x: number
    y: number
    price: string
    position: 'left' | 'right'
    seriesGroup: SeriesGroup | undefined
    anchorOriginHorizontal?: 'left' | 'right'
    transformOriginHorizontal?: 'left' | 'right'
}

export type ChartContextMenuHostHandle = {
    open: (anchor: ChartContextMenuAnchor) => void
}

const CLOSED_ANCHOR: ChartContextMenuAnchor = {
    x: 0,
    y: 0,
    price: '',
    position: 'left',
    seriesGroup: undefined
}

export const CHART_CONTEXT_MENU_ATTR = 'data-chart-context-menu'
export const CHART_CONTEXT_MENU_CHILD_ATTR = 'data-chart-context-menu-child'
export const CHART_CONTEXT_MENU_SELECTOR = `[${CHART_CONTEXT_MENU_ATTR}], [${CHART_CONTEXT_MENU_CHILD_ATTR}]`

type Props = {
    viewKey: string
}

const ChartContextMenuHost = forwardRef<ChartContextMenuHostHandle, Props>(function ChartContextMenuHost(
    { viewKey },
    ref
) {
    const [anchorPosition, setAnchorPosition] = useState<ChartContextMenuAnchor>(CLOSED_ANCHOR)

    useImperativeHandle(
        ref,
        () => ({
            open: setAnchorPosition
        }),
        []
    )

    return (
        <ChartContextMenuOptions
            anchorPosition={anchorPosition}
            setAnchorPosition={setAnchorPosition}
            viewKey={viewKey}
        />
    )
})

export default memo(ChartContextMenuHost)
